/**
 * Auth Utility
 * 
 * Handles auto-login and authentication state management
 */

import api from './api';

/**
 * Auto Login
 * 
 * Calls backend auto-login endpoint
 * Backend reads MSISDN from enriched headers
 * Returns user data and JWT token
 * 
 * @param {Boolean} saveToStorage - Whether to save to localStorage (default: false)
 */
export const autoLogin = async (saveToStorage = false) => {
  try {
    console.log('📡 Calling backend auto-login endpoint...');
    const response = await api.post('/auth/auto-login');
    
    console.log('📥 Backend response received:', response.data);
    
    if (response.data.success) {
      // Only save to localStorage if explicitly requested
      if (saveToStorage) {
        localStorage.setItem('accessToken', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('subscription', JSON.stringify(response.data.data.subscription));
        localStorage.setItem('isLoggedIn', 'true');
        console.log('💾 Data saved to localStorage');
      }
      
      return {
        success: true,
        user: response.data.data.user,
        subscription: response.data.data.subscription,
        isSubscribed: response.data.data.isSubscribed,
        token: response.data.data.token
      };
    }
    
    throw new Error(response.data.message || 'Auto-login failed');
  } catch (error) {
    console.error('❌ Auto-login error:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};

/**
 * Get Current User
 * 
 * Fetches current user information from backend
 */
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    
    if (response.data.success) {
      // Update stored user data
      localStorage.setItem('user', JSON.stringify(response.data.data.user));
      localStorage.setItem('subscription', JSON.stringify(response.data.data.subscription));
      
      return {
        success: true,
        user: response.data.data.user,
        subscription: response.data.data.subscription,
        isSubscribed: response.data.data.isSubscribed
      };
    }
    
    throw new Error(response.data.message || 'Failed to fetch user');
  } catch (error) {
    console.error('Get current user error:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};

/**
 * Logout
 * 
 * Clears authentication data
 */
export const logout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('subscription');
  localStorage.removeItem('isLoggedIn');
  window.location.href = '/signin';
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('accessToken');
};

/**
 * Get stored user data
 */
export const getStoredUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

/**
 * Get stored subscription data
 */
export const getStoredSubscription = () => {
  const subStr = localStorage.getItem('subscription');
  return subStr ? JSON.parse(subStr) : null;
};
